import Stage from './Stage';
import BoxGroup from './BoxGroup';
import LittleMan from './LittleMan';
import Sound from '../util/Sound';
import Leaderboard from '../util/Leaderboard';
import showUpdateNotice from '../util/UpdateNotice';
import {SKINS, selectedSkin} from '../util/Skins';
import {disposeObject} from '../util/Resources';
import {setFrameAction, pauseAnimations, resumeAnimations, resetAnimations} from '../util/TweenUtil';

export default class JumpGame {
  constructor() {
    this.record = this.loadRecord();
    this.sound = new Sound(this.record.sound);
    this.leaderboard = new Leaderboard();
    this.state = 'menu';
    this.stage = new Stage();
    this.createUI();
    setFrameAction(() => this.stage.render());
    this.resetWorld();
    this.bindInput();
    this.showPanel('跳一跳', '按住蓄力，松开跳跃。落在中心可连续加分。\n特殊图案或方块停留有加分哦', '开始游戏');
    showUpdateNotice(this.ui);
  }
  loadRecord() {
    try {
      const data = JSON.parse(localStorage.getItem('web-jump-v1') || '{}');
      return {best: Number.isFinite(data.best) ? Math.max(0, data.best) : 0,
        games: Number.isFinite(data.games) ? Math.max(0, data.games) : 0, sound: data.sound !== false,
        skin: selectedSkin(data.skin, data.best) ? data.skin : null};
    } catch (_) { return {best: 0, games: 0, sound: true}; }
  }
  saveRecord() {
    try { localStorage.setItem('web-jump-v1', JSON.stringify(this.record)); } catch (_) {}
  }
  createUI() {
    this.ui = document.createElement('div');
    this.ui.className = 'game-ui';
    this.ui.innerHTML = `<header><div><span class="label">本次得分</span><strong id="score">0</strong><span id="best"></span></div>
      <nav><button id="skins" type="button" aria-haspopup="dialog" aria-controls="skins-dialog">皮肤</button><button id="notice" type="button" aria-label="游戏公告" aria-haspopup="dialog" aria-controls="notice-dialog" title="游戏公告"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4M12 2V1"/></svg></button><button id="ranking" type="button">排行榜</button><button id="sound" type="button"></button><button id="pause" type="button" disabled>暂停</button></nav></header>
      <p id="feedback" role="status" aria-live="polite">按住蓄力 · 松开跳跃</p>
      <footer><div class="charge-track" role="progressbar" aria-label="蓄力" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><i></i></div><p>按住屏幕或空格键，松开跳跃</p></footer>
      <section class="overlay"><div class="panel"><h1></h1><p></p><small id="upload-status" role="status"></small><button id="primary" type="button">开始游戏</button><button id="restart" type="button" hidden>重新开始</button></div></section>
      <dialog class="ranking-dialog" aria-labelledby="ranking-title"><div class="ranking-heading"><h2 id="ranking-title">最高分排行榜</h2><button id="ranking-close" type="button" aria-label="关闭排行榜">关闭</button></div>
        <form id="nickname-form"><label for="nickname">我的昵称</label><div class="nickname-row"><input id="nickname" autocomplete="nickname" maxlength="32"><button type="submit">保存</button></div></form>
        <p id="ranking-status" role="status" aria-live="polite"></p><p id="my-ranking"></p>
        <ol id="ranking-list" aria-label="前一百名"></ol><p class="ranking-note">同分按达到时间排序 · 榜单最多延迟 60 秒<br>身份保存在此浏览器，清除数据后需重新开始</p><button id="ranking-refresh" type="button">刷新 / 重试上传</button>
      </dialog>
      <dialog id="skins-dialog" class="skins-dialog" aria-labelledby="skins-title"><div class="ranking-heading"><h2 id="skins-title">棋子皮肤</h2><button id="skins-close" type="button" aria-label="关闭皮肤">关闭</button></div><p id="skins-best"></p><div class="skin-grid"></div><p class="skin-note">达到对应最高分后即可选择，选择后棋子立即更换。</p><button id="skin-default" type="button">使用默认棋子</button></dialog><dialog id="notice-dialog" class="notice-dialog" aria-labelledby="notice-title" aria-describedby="notice-message"><div class="ranking-heading"><h2 id="notice-title">游戏公告</h2><button id="notice-close" type="button" aria-label="关闭游戏公告" autofocus>关闭</button></div><p id="notice-message">各位玩家大大，本游戏尚未完全完善，有什么bug请向“942053469”（QQ号）反馈哦。</p></dialog>`;
    document.body.appendChild(this.ui);
    this.scoreNode = this.ui.querySelector('#score');
    this.bestNode = this.ui.querySelector('#best');
    this.feedback = this.ui.querySelector('#feedback');
    this.overlay = this.ui.querySelector('.overlay');
    this.pauseButton = this.ui.querySelector('#pause');
    this.ui.querySelector('#primary').onclick = () => this.state === 'paused' ? this.resume() : this.newGame();
    this.ui.querySelector('#restart').onclick = () => this.newGame();
    this.pauseButton.onclick = () => this.pause();
    const skinsDialog = this.ui.querySelector('#skins-dialog');
    this.ui.querySelector('#skins').onclick = () => {
      const wasPlaying = this.state === 'playing';
      this.pause(); this.resumeAfterSkins = wasPlaying;
      this.renderSkins(); skinsDialog.showModal();
    };
    this.ui.querySelector('#skins-close').onclick = () => skinsDialog.close();
    skinsDialog.addEventListener('close', () => {
      if (this.resumeAfterSkins) this.resume();
      this.resumeAfterSkins = false;
    });
    this.ui.querySelector('#skin-default').onclick = () => this.selectSkin(null);
    const noticeDialog = this.ui.querySelector('#notice-dialog');
    this.ui.querySelector('#notice').onclick = () => {
      this.pause(); noticeDialog.showModal();
    };
    this.ui.querySelector('#notice-close').onclick = () => noticeDialog.close();
    const dialog = this.ui.querySelector('.ranking-dialog');
    this.ui.querySelector('#ranking').onclick = () => {
      this.pause(); dialog.showModal();
      this.ui.querySelector('#nickname').value = this.leaderboard.profile.name;
      this.refreshRanking();
    };
    this.ui.querySelector('#ranking-close').onclick = () => dialog.close();
    this.ui.querySelector('#ranking-refresh').onclick = () => this.refreshRanking();
    this.ui.querySelector('#nickname-form').onsubmit = async event => {
      event.preventDefault();
      const button = event.currentTarget.querySelector('button');
      button.disabled = true;
      try { await this.leaderboard.rename(this.ui.querySelector('#nickname').value); await this.refreshRanking(); }
      catch (error) {
        this.ui.querySelector('#ranking-status').textContent = error.message;
        if (error.code === 'NAME_TAKEN') window.alert(error.message);
      }
      finally { button.disabled = false; }
    };
    this.ui.querySelector('#sound').onclick = () => {
      this.record.sound = !this.record.sound; this.sound.enabled = this.record.sound;
      this.sound.unlock(); this.saveRecord(); this.updateHUD();
    };
  }
  async refreshRanking() {
    const status = this.ui.querySelector('#ranking-status');
    const refresh = this.ui.querySelector('#ranking-refresh');
    if (refresh.disabled) return;
    refresh.disabled = true; status.textContent = '正在读取排行榜…';
    try {
      const {players, player} = await this.leaderboard.load();
      this.ui.querySelector('#my-ranking').textContent = player
        ? `我的最高分 ${player.score} · 第 ${player.rank} 名` : '完成一次挑战后即可上榜';
      const list = this.ui.querySelector('#ranking-list'); list.replaceChildren();
      players.forEach(row => {
        const item = document.createElement('li');
        const name = document.createElement('span'); name.textContent = `${row.rank}. ${row.name}`;
        const score = document.createElement('b'); score.textContent = row.score;
        item.append(name, score); list.appendChild(item);
      });
      status.textContent = players.length ? '前 100 名 · 每位玩家只保留最高分' : '暂无成绩，来成为第一位玩家吧';
    } catch (error) { status.textContent = error.message; }
    finally { refresh.disabled = false; }
  }
  renderSkins() {
    this.ui.querySelector('#skins-best').textContent = `历史最高分 ${this.record.best}`;
    const grid = this.ui.querySelector('.skin-grid'); grid.replaceChildren();
    SKINS.forEach(skin => {
      const unlocked = this.record.best >= skin.score;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'skin-card'; button.disabled = !unlocked;
      button.setAttribute('aria-pressed', String(this.record.skin === skin.id));
      const frame = document.createElement('span'); frame.className = 'skin-preview';
      if (skin.image) { const image = document.createElement('img'); image.src = skin.image; image.alt = skin.name; frame.appendChild(image); }
      const name = document.createElement('b'); name.textContent = skin.name;
      const condition = document.createElement('span'); condition.textContent = `达到 ${skin.score} 分`;
      const status = document.createElement('span'); status.textContent = !unlocked ? '未解锁' : this.record.skin === skin.id ? '已选择' : '已解锁';
      button.append(frame, name, condition, status);
      button.onclick = () => this.selectSkin(skin.id); grid.appendChild(button);
    });
    this.ui.querySelector('#skin-default').setAttribute('aria-pressed', String(!this.record.skin));
  }
  selectSkin(id) {
    const skin = selectedSkin(id, this.record.best);
    if (id && !skin) return;
    this.record.skin = skin ? skin.id : null;
    this.saveRecord(); this.littleMan.trunk.setSkin(skin);
    this.stage.render(); this.renderSkins();
  }
  resetWorld() {
    this.sound.stopCharge();
    resetAnimations();
    if (this.boxGroup) this.boxGroup.dispose();
    if (this.littleMan) {
      const man = this.littleMan;
      man.particle.particles.forEach(particle => man.body.add(particle));
      disposeObject(man.body);
      const fragments = [...man.tail.cachedTailFragment, ...man.tail.usedTailFragment];
      fragments.forEach(fragment => this.stage.scene.remove(fragment.mesh));
      man.tail.geometry.dispose(); man.tail.material.dispose();
    }
    this.stage.camera.position.y = this.stage.baseCameraY;
    this.score = 0; this.combo = 0; this.recordBroken = false; this.setCharge(0);
    this.boxGroup = new BoxGroup();
    this.boxGroup.createBox(); this.boxGroup.createBox(); this.boxGroup.enterStage(this.stage);
    this.littleMan = new LittleMan(this.stage, this.boxGroup, this);
    this.littleMan.trunk.setSkin(selectedSkin(this.record.skin, this.record.best));
    this.boxGroup.setLittleMan(this.littleMan); this.littleMan.enterStage(this.stage);
    this.boxGroup.updatePosition({duration: 0});
    this.updateHUD(); this.stage.render();
  }
  newGame() {
    this.clearInput(); this.sound.unlock(); this.resetWorld();
    this.state = 'playing'; this.record.games++; this.saveRecord();
    this.overlay.hidden = true; this.pauseButton.disabled = false;
    this.stage.renderer.domElement.focus({preventScroll: true});
    this.feedback.textContent = '按住蓄力 · 松开跳跃';
    this.ui.querySelector('#upload-status').textContent = '';
    this.littleMan.box.doAnimate(this);
  }
  showPanel(title, text, button) {
    this.overlay.hidden = false;
    this.overlay.querySelector('h1').textContent = title;
    this.overlay.querySelector('p').textContent = text;
    this.ui.querySelector('#primary').textContent = button;
    this.ui.querySelector('#restart').hidden = this.state !== 'paused';
  }
  updateHUD() {
    this.scoreNode.textContent = this.score;
    this.bestNode.textContent = `最高 ${this.record.best}`;
    const button = this.ui.querySelector('#sound');
    button.textContent = this.record.sound ? '声音：开' : '声音：关';
    button.setAttribute('aria-pressed', String(this.record.sound));
  }
  setCharge(t) {
    const track = this.ui.querySelector('.charge-track');
    track.querySelector('i').style.transform = `scaleX(${t})`;
    track.setAttribute('aria-valuenow', Math.round(t * 100));
  }
  onLanding(result) {
    if (result === 'stay') {
      this.combo = 0; this.feedback.textContent = '还在原平台，试着多蓄一点力';
      this.sound.play('land'); return;
    }
    const perfect = result === 'perfect';
    this.combo = perfect ? this.combo + 1 : 0;
    const points = perfect ? Math.min(10, this.combo * 2) : 1;
    this.score += points;
    this.feedback.textContent = perfect ? `完美落点！+${points} · 连续 ${this.combo} 次` : '+1 · 落地成功';
    const breakthrough = this.updateBest();
    this.sound.play(breakthrough ? 'breakthrough' : (perfect ? 'perfect' : 'land')); this.updateHUD();
  }
  updateBest() {
    if (this.score <= this.record.best) return false;
    this.record.best = this.score; this.saveRecord();
    if (this.recordBroken) return false;
    this.recordBroken = true;
    return true;
  }
  onFailStart() { this.sound.play('fail'); this.pauseButton.disabled = true; this.feedback.textContent = '没站稳，再试一次'; }
  onPlatformBonus(points, label = '魔方') {
    this.score += points;
    this.feedback.textContent = `${label}停留奖励！+${points}`;
    const breakthrough = this.updateBest();
    this.sound.play(breakthrough ? 'breakthrough' : 'land'); this.updateHUD();
  }
  finish() {
    this.state = 'gameover'; this.clearInput(); this.saveRecord();
    this.showPanel('本次挑战结束', `得分 ${this.score} · 最高 ${this.record.best} · 已挑战 ${this.record.games} 次`, '再来一次');
    const status = this.ui.querySelector('#upload-status');
    status.textContent = '正在同步排行榜…';
    this.leaderboard.submit(this.score).then(() => {
      status.textContent = '最高分已同步到排行榜';
    }).catch(error => {
      status.textContent = error.code === 'NAME_TAKEN' ? error.message : '暂未同步，成绩已保留，可在排行榜中重试';
      if (error.code === 'NAME_TAKEN') window.alert(error.message);
    });
  }
  pause() {
    if (this.state !== 'playing') return;
    this.clearInput(); this.littleMan.cancelCharge();
    this.state = 'paused'; pauseAnimations(); this.pauseButton.disabled = true;
    this.showPanel('已暂停', '准备好后继续这次挑战', '继续游戏');
  }
  resume() {
    if (this.state !== 'paused') return;
    this.state = 'playing'; this.overlay.hidden = true;
    this.stage.renderer.domElement.focus({preventScroll: true});
    this.pauseButton.disabled = this.littleMan.state === LittleMan.STATE.falling;
    resumeAnimations();
  }
  clearInput() {
    const canvas = this.stage.renderer.domElement;
    if (this.pointerId != null && canvas.hasPointerCapture(this.pointerId)) canvas.releasePointerCapture(this.pointerId);
    this.pointerId = null; this.inputSource = null;
  }
  bindInput() {
    const canvas = this.stage.renderer.domElement;
    canvas.tabIndex = 0;
    canvas.setAttribute('aria-label', '跳一跳游戏，按住空格蓄力，松开跳跃');
    canvas.addEventListener('pointerdown', event => {
      if (!event.isPrimary || event.button !== 0 || this.inputSource || this.state !== 'playing' || this.littleMan.state !== LittleMan.STATE.init) return;
      event.preventDefault(); this.sound.unlock(); this.pointerId = event.pointerId;
      this.inputSource = 'pointer'; canvas.setPointerCapture(event.pointerId); this.littleMan.beginCharge();
    });
    canvas.addEventListener('pointerup', event => {
      if (event.pointerId !== this.pointerId) return;
      event.preventDefault(); this.littleMan.releaseCharge(); this.clearInput();
    });
    const cancel = event => {
      if (event.pointerId !== this.pointerId) return;
      this.littleMan.cancelCharge(); this.clearInput();
    };
    canvas.addEventListener('pointercancel', cancel); canvas.addEventListener('lostpointercapture', cancel);
    canvas.addEventListener('contextmenu', event => event.preventDefault());
    window.addEventListener('keydown', event => {
      if (this.ui.querySelector('dialog[open]')) return;
      if (event.code === 'Escape') { this.state === 'paused' ? this.resume() : this.pause(); return; }
      if (event.code !== 'Space' || /BUTTON|INPUT|TEXTAREA/.test(event.target.tagName)) return;
      event.preventDefault();
      if (event.repeat || this.inputSource || this.state !== 'playing' || this.littleMan.state !== LittleMan.STATE.init) return;
      this.inputSource = 'keyboard'; this.sound.unlock(); this.littleMan.beginCharge();
    });
    window.addEventListener('keyup', event => {
      if (event.code !== 'Space' || this.inputSource !== 'keyboard') return;
      event.preventDefault(); this.littleMan.releaseCharge(); this.clearInput();
    });
    window.addEventListener('blur', () => this.pause());
    document.addEventListener('visibilitychange', () => { if (document.hidden) this.pause(); });
  }
  start() { this.stage.render(); }
}


